import { MediaSort } from "shared/types/files";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface MLSortByProps {
  disabled: boolean;
  value: MediaSort;
  onChange(sort: MediaSort): void;
  className?: string;
}

export function MLSortBy({
  value,
  onChange,
  disabled,
  className,
}: MLSortByProps) {
  return (
    <Select
      value={value}
      onValueChange={(val) => onChange(val as MediaSort)}
      disabled={disabled}
    >
      <SelectTrigger
        className={cn(
          "h-8 w-full md:w-[180px] font-inter font-medium",
          className
        )}
      >
        <SelectValue placeholder="Sort by..." />
      </SelectTrigger>
      <SelectContent align="end">
        {SortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

const SortOptions = [
  {
    label: "Recently Added",
    value: MediaSort.addedNewestToOldest,
  },
  {
    label: "Oldest Added",
    value: MediaSort.addedOldestToNewest,
  },
  {
    label: "Recently Updated",
    value: MediaSort.updatedNewestToOldest,
  },
  {
    label: "Oldest Updated",
    value: MediaSort.updatedOldestToNewest,
  },
  {
    label: "Alphabetical A-Z",
    value: MediaSort.alphabetical,
  },
  {
    label: "Alphabetical Z-A",
    value: MediaSort.alphabeticalReverse,
  },
];
